import { CoreInterfaces, DTOs } from "./../../Models";
import * as Constants from "../../Constants/Constants";
import { applyUpdatesOnQuestionChange } from "src/utils/processors/Questions";
import { v4 as uuidv4 } from "uuid";
import {
  arrayMove,
  applyChangesTimestampOnNextState,
  handleAnnualPayrollRoutinesState,
  handleAnnualReportingListedCompaniesState,
  handleAnnualReportingState,
  handleEngagementCounselingState,
  handleExtraServiceState,
  handleInterimListedCompaniesState,
  handleYearlyServiceState,
  handleAuditServices,
  handleTaxEngagementLetters,
  isFinalorOutdatedVersion,
} from "src/utils";

export function servicesReducer(
  state: CoreInterfaces.AppState,
  action: { type: Constants.AppStateActions; payload?: any }
): Partial<CoreInterfaces.AppState> {
  switch (action.type) {
    case Constants.AppStateActions.ServicesOverride: {
      const nextServices = action.payload as Array<DTOs.ServiceDTO>;
      const nextState: CoreInterfaces.AppState = {
        ...state,
        services: nextServices,
      };

      applyChangesTimestampOnNextState(nextState);

      return nextState;
    }
    case Constants.AppStateActions.UpdateServiceStaffingAdjustmentCost: {
      const { serviceCode, adjustmentCost } = action.payload as {
        serviceCode: Constants.ServiceCode;
        adjustmentCost: number;
      };
      const nextServices = state.services.map((eachService) => {
        if (eachService.data.code === serviceCode) {
          const updatedService = {
            ...eachService,
            data: {
              ...eachService.data,
              staffingAdjustments: {
                ...eachService.data.staffingAdjustments,
                cost: adjustmentCost,
              },
            },
          };
          return updatedService;
        } else {
          return eachService;
        }
      });

      handleYearlyServiceState(nextServices);
      handleAnnualPayrollRoutinesState(nextServices);
      handleAnnualReportingListedCompaniesState(nextServices);
      handleInterimListedCompaniesState(nextServices);
      handleAnnualReportingState(nextServices);
      handleEngagementCounselingState(nextServices);
      handleExtraServiceState(nextServices, isFinalorOutdatedVersion(state));
      handleAuditServices(nextServices);
      handleTaxEngagementLetters(nextServices);

      const nextState: CoreInterfaces.AppState = {
        ...state,
        services: nextServices,
      };

      applyChangesTimestampOnNextState(nextState);

      // TODO to improve that
      [
        Constants.ServiceCode.GeneralInformation,
        Constants.ServiceCode.PayrollAndExpenseAndTravelInvoiceManagement,
        Constants.ServiceCode.AnnualReporting,
        Constants.ServiceCode.OtherAccountAndReconciliation,
      ].forEach((serviceCode) => {
        applyUpdatesOnQuestionChange(
          nextState,
          state.services.find(
            (eachService) => eachService.data.code === serviceCode
          )
        );
      });

      return nextState;
    }
    case Constants.AppStateActions
      .UpdateServiceStaffingAdjustmentExtendedCost: {
      const { serviceCode, extendedPriceListPanelCost } = action.payload as {
        serviceCode: Constants.ServiceCode;
        extendedPriceListPanelCost: number;
      };
      const nextServices = state.services.map((eachService) => {
        if (eachService.data.code === serviceCode) {
          const updatedService = {
            ...eachService,
            data: {
              ...eachService.data,
              staffingAdjustments: {
                ...eachService.data.staffingAdjustments,
                extendedPriceListPanelCost: extendedPriceListPanelCost,
              },
            },
          };
          return updatedService;
        } else {
          return eachService;
        }
      });

      handleYearlyServiceState(nextServices);
      handleAnnualPayrollRoutinesState(nextServices);
      handleAnnualReportingListedCompaniesState(nextServices);
      handleInterimListedCompaniesState(nextServices);
      handleAnnualReportingState(nextServices);
      handleEngagementCounselingState(nextServices);
      handleExtraServiceState(nextServices, isFinalorOutdatedVersion(state));
      handleAuditServices(nextServices);
      handleTaxEngagementLetters(nextServices);

      const nextState: CoreInterfaces.AppState = {
        ...state,
        services: nextServices,
      };

      applyChangesTimestampOnNextState(nextState);

      // TODO to improve that
      [
        Constants.ServiceCode.GeneralInformation,
        Constants.ServiceCode.PayrollAndExpenseAndTravelInvoiceManagement,
        Constants.ServiceCode.AnnualReporting,
        Constants.ServiceCode.OtherAccountAndReconciliation,
      ].forEach((serviceCode) => {
        applyUpdatesOnQuestionChange(
          nextState,
          state.services.find(
            (eachService) => eachService.data.code === serviceCode
          )
        );
      });

      return nextState;
    }
    case Constants.AppStateActions.ServiceExpandChange: {
      const nextService = action.payload as DTOs.ServiceDTO;

      const nextServices = state.services.map((eachService) => {
        if (eachService.data.code === nextService.data.code) {
          return nextService;
        } else {
          return eachService;
        }
      });

      const nextState: CoreInterfaces.AppState = {
        ...state,
        services: nextServices,
      };

      return nextState;
    }
    case Constants.AppStateActions.ServiceAdditionalCostAdjustementChange: {
      const { serviceCode, additionalCostCode, costValue } =
        action.payload as CoreInterfaces.ServiceAdditionalCostAdjustement;
      const serviceToBeUpdated = state.services.find(
        (serviceDTO) => serviceDTO.data.code === serviceCode
      );
      if (serviceToBeUpdated) {
        const updatedService = {
          ...serviceToBeUpdated,
          data: {
            ...serviceToBeUpdated.data,
            additionalCosts: serviceToBeUpdated.data.additionalCosts.map(
              (additionalCostDTO) => {
                if (additionalCostDTO.data.code === additionalCostCode) {
                  const updatedTask = {
                    ...additionalCostDTO,
                    data: {
                      ...additionalCostDTO.data,
                      adjustments: {
                        ...additionalCostDTO.data.adjustments,
                        Cost: Number(costValue),
                      },
                    },
                  };
                  return updatedTask;
                } else {
                  return additionalCostDTO;
                }
              }
            ),
          },
        };

        const nextstate = {
          ...state,
          services: state.services.map((eachService) => {
            if (eachService.data.code === updatedService.data.code) {
              return updatedService;
            }
            return eachService;
          }),
        };
        return nextstate;
      }
      return state;
    }
    case Constants.AppStateActions.TaskUpdated: {
      const serviceDTO = action.payload.serviceDTO as DTOs.ServiceDTO;
      const taskDTO = action.payload.taskDTO as DTOs.TaskDTO;
      const nextState = {
        ...state,
        services: state.services.map((eachService) => {
          if (eachService.data.code === serviceDTO.data.code) {
            const nextService = {
              ...eachService,
              data: {
                ...eachService.data,
                tasks: eachService.data.tasks.map((eachTask) => {
                  if (eachTask.data.code === taskDTO.data.code) {
                    return taskDTO;
                  } else {
                    return eachTask;
                  }
                }),
              },
            };
            return nextService;
          } else {
            return eachService;
          }
        }),
      };
      applyChangesTimestampOnNextState(nextState);
      return nextState;
    }
    case Constants.AppStateActions.TaskAdd: {
      const serviceDTO = action.payload.serviceDTO as DTOs.ServiceDTO;
      const taskDTO = action.payload.taskDTO as DTOs.TaskDTO;
      const nextState = {
        ...state,
        services: state.services.map((eachService) => {
          if (eachService.data.code === serviceDTO.data.code) {
            const nextService = {
              ...eachService,
              data: {
                ...eachService.data,
                tasks: [...eachService.data.tasks, taskDTO],
              },
            };
            return nextService;
          } else {
            return eachService;
          }
        }),
      };

      applyChangesTimestampOnNextState(nextState);

      return nextState;
    }
    case Constants.AppStateActions.TaskOrderChange: {
      const serviceDTO = action.payload.serviceDTO as DTOs.ServiceDTO;
      const taskDTO = action.payload.taskDTO as DTOs.TaskDTO;
      const previousTargetTaskCode = action.payload.previousTargetTaskCode;
      const nextState = {
        ...state,
        services: state.services.map((eachService) => {
          if (eachService.data.code === serviceDTO.data.code) {
            const oldIndex = eachService.data.tasks.findIndex(
              (task) => task.data.code === taskDTO.data.code
            );
            let newIndex = previousTargetTaskCode
              ? eachService.data.tasks.findIndex(
                  (task) => task.data.code === previousTargetTaskCode
                )
              : 0;
            if (previousTargetTaskCode && newIndex < oldIndex) {
              newIndex++;
            }

            const nextService = {
              ...eachService,
              data: {
                ...eachService.data,
                tasks: arrayMove(eachService.data.tasks, oldIndex, newIndex),
              },
            };
            return nextService;
          } else {
            return eachService;
          }
        }),
      };
      applyChangesTimestampOnNextState(nextState);

      return nextState;
    }
    case Constants.AppStateActions.TaskDelete: {
      const serviceDTO = action.payload.serviceDTO as DTOs.ServiceDTO;
      const taskDTO = action.payload.taskDTO as DTOs.TaskDTO;
      const nextState = {
        ...state,
        services: state.services.map((eachService) => {
          if (eachService.data.code === serviceDTO.data.code) {
            const nextService = {
              ...eachService,
              data: {
                ...eachService.data,
                tasks: [
                  ...eachService.data.tasks.filter(
                    (item) => item.data.code !== taskDTO.data.code
                  ),
                ],
              },
            };
            return nextService;
          } else {
            return eachService;
          }
        }),
      };
      applyChangesTimestampOnNextState(nextState);
      return nextState;
    }
    case Constants.AppStateActions.TaskEdit: {
      const serviceDTO = action.payload.serviceDTO as DTOs.ServiceDTO;
      const updatedTaskDTO = action.payload.taskDTO as DTOs.TaskDTO;
      const nextState = {
        ...state,
        services: state.services.map((eachService) => {
          if (eachService.data.code !== serviceDTO.data.code)
            return eachService;

          const updatedTasks: DTOs.TaskDTO[] = [];

          eachService.data.tasks.forEach((task) => {
            if (task.data.code === updatedTaskDTO.data.code) {
              const oldTask = {
                data: {
                  ...task.data,
                  code: task.data.code + "_old",
                },
                state: {
                  ...task.state,
                  isActive: false,
                },
              };
              updatedTasks.push(oldTask);

              const newClonedTask = {
                data: {
                  ...updatedTaskDTO.data,
                  code: updatedTaskDTO.data.code + "_new",
                },
                state: {
                  ...updatedTaskDTO.state,
                  isActive: true,
                },
              };
              updatedTasks.push(newClonedTask);
            } else {
              updatedTasks.push({
                data: { ...task.data },
                state: { ...task.state },
              });
            }
          });

          return {
            ...eachService,
            data: {
              ...eachService.data,
              tasks: updatedTasks,
            },
          };
        }),
      };

      applyChangesTimestampOnNextState(nextState);

      return nextState;
    }
    case Constants.AppStateActions.TaskDuplicate: {
      const serviceDTO = action.payload.serviceDTO as DTOs.ServiceDTO;
      const taskDTO = action.payload.taskDTO as DTOs.TaskDTO;

      const nextState = {
        ...state,
        services: state.services.map((eachService) => {
          if (eachService.data.code !== serviceDTO.data.code)
            return eachService;

          const tasks = eachService.data.tasks;
          const originalIndex = tasks.findIndex(
            (t) => t.data.code === taskDTO.data.code
          );
          console.log(taskDTO.data.calculationMethod);

          if (originalIndex === -1) return eachService;
          const duplicatedTask = {
            data: {
              ...taskDTO.data,
              code: uuidv4(),
              calculationMethod:
                serviceDTO.data.code === Constants.ServiceCode.ExtraServices
                  ? Constants.TaskCalculationMethod.TimeXPricePerHour
                  : taskDTO.data.calculationMethod,
            },
            state: {
              ...taskDTO.state,
            },
          };
          const newTasks = [
            ...tasks.slice(0, originalIndex + 1),
            duplicatedTask,
            ...tasks.slice(originalIndex + 1),
          ];

          return {
            ...eachService,
            data: {
              ...eachService.data,
              tasks: newTasks,
            },
          };
        }),
      };

      applyChangesTimestampOnNextState(nextState);
      return nextState;
    }
    default:
      return {};
  }
}
